import { UndoOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import dayjs from 'dayjs';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import { ChartGraphListByChartType } from '@/entities/chart/model/constants';
import useChartStateAction from '@/features/(charts)/chart-controller/hooks/use-chart-state-action/useChartStateAction';
import { directionEnabledGraphList } from '@/features/(charts)/chart-renderer/lib/conditions';
import {
  ChartGraphDirectionMap,
  ChartGraphMap,
} from '@/features/(charts)/chart-renderer/model/chart-maps';

type Props = {
  chartInfo: ChartContextProps;
  isFetched: boolean;
  dataUpdatedAt: number;
  refetch: () => void;
};

const ChartChartSettingBar = (props: Props) => {
  const { isFetched, dataUpdatedAt, refetch, chartInfo } = props;
  const { state } = chartInfo;

  const { onGraphChange, onGraphDirectionChange } = useChartStateAction(
    props.chartInfo,
  );

  const graphOptions = ChartGraphListByChartType[state.type].map((graph) => {
    return {
      label: ChartGraphMap.get(graph),
      value: graph,
    };
  });
  const showDirectionSelect = directionEnabledGraphList.includes(state.graph);

  return (
    <Flex j="space-between" a="center" height="32px">
      <Flex g={8} a="center">
        <>
          <Select
            value={state.graph}
            options={graphOptions}
            style={{ width: 140 }}
            onChange={onGraphChange}
          />
          {showDirectionSelect && (
            <Select
              value={state.graph_direction || null}
              options={ChartGraphDirectionMap.toArray()}
              style={{ width: 120 }}
              onChange={onGraphDirectionChange}
            />
          )}
        </>
      </Flex>
      <Flex a="center" g={4}>
        {isFetched && (
          <Button
            variant="ghost"
            onClick={() => refetch()}
            rightIcon={<UndoOutlined />}
          >
            <Typo>Data from {dayjs.tz(dataUpdatedAt).fromNow()}</Typo>
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default ChartChartSettingBar;
